import axiosInstance from "./http/axios_instance"
const http = axiosInstance("/",  null, "/")

const getTemplateUI = (yaml, summary_id) => http.get("/protected/template_ui/" + yaml + "/" + summary_id);
const getTemplateUIById = (templateId, summaryId) =>
    http.get(`/protected/template_ui_yaml/${templateId}/${summaryId}`);

export default {
    getTemplateUI,
    getTemplateUIById
}
